$(document).ready(function (e) {
    $('.sortable-calendar-mapping').sortable({
        cursor: 'grab',
        connectWith: ".sortable-calendar-mapping",
    });

    $('#calendar-table').on('change', function (e) {
        $('.calendar-mappings-holder').empty();
        addTableFilters();
        addStartEndFields();
    });

    function addTableFilters(){
        let id = $('#calendar-table').val(),
            $calendar_filter = $('#calendar-filter')

        if(id.length){
            $.ajax({
                type: 'GET',
                url : '/tablebuilder/table/filters',
                data: {
                    id
                },
                success: function(filters) {
                    let filterOptions = '<option value="">Select Filter</option>',
                        $activeSection = $('.related-section.activeSection');
                    if (filters) {
                        for (let key in filters) {
                            if (filters.hasOwnProperty(key)) {
                                filterOptions += `<option value="${key}">${filters[key]}</option>`;
                            }
                        }
                    }
                    $calendar_filter.html(filterOptions);
                }
            })
        }else{
            $calendar_filter.empty();
        }
    }

    function addStartEndFields(){
        let id = $('#calendar-table').val(),
            $start_field = $('#calendar-start-field'),
            $end_field = $('#calendar-end-field');

        if(id.length){
            $.ajax({
                type: 'GET',
                url: '/tablebuilder/table/fields/dropdown',
                data: {
                    id,
                    type: 'date',
                    timestamps: 1
                },
                success: function(res) {
                    $start_field.html(res);
                    $end_field.html(res);
                }
            })
        }else{
            $start_field.empty();
            $end_field.empty();
        }
    }

    $(document).on('change', '.calendar-field-value-type, .calendar-field', function (e) {
        let value = parseInt($(this).val());

        let $mapping = $(this).parents('.calendar-mapping'),
            $custom_value = $($mapping).find('.custom-value-holder'),
            field = $($mapping).find('.calendar-field').val(),
            field_type = $($mapping).find('.calendar-field').find('option:selected').attr('data-field-type'),
            field_type_value = parseInt($($mapping).find('.calendar-field-value-type').val()),
            required = parseInt($(this).find(':selected').attr('data-is-required'));

        if (!field_type.length || !field.length) {
            return;
        }

        if(required === 1){
            $mapping.find('.toggle-required').prop('checked', true);
        }else{
            $mapping.find('.toggle-required').prop('checked', false);
        }

        if (field_type_value === 2) {
            $mapping.find('.field-custom-value').val('').attr('disabled', false);
            $.ajax({
                type: 'GET',
                url: '/tables/field/render',
                data: {
                    field: field,
                    webform: true
                },
                success: function (res) {
                    if (res) {
                        $custom_value.html(res).removeClass('d-none');
                        $('.selectpicker').selectpicker('refresh');
                    }
                }
            });
        } else {
            $($mapping).find('.custom-value-holder').empty();
        }
    });

    $('.add-calendar-mapping').on('click', function (e) {
        let table_id = $('#calendar-table').val();
        if (table_id.length) {
            $.ajax({
                type: "GET",
                url: '/settings/calendar/mapping',
                data: {
                    table_id
                },
                success: function (mapping) {
                    $('.calendar-mappings-holder').append(mapping);
                    $('.sortable-calendar-mapping').sortable({
                        cursor: 'grab',
                        connectWith: ".sortable-calendar-mapping",
                    });
                }
            });
        } else {
            alert('Please select Table');
        }
    });

    $(document).on('click', '.remove-calendar-mapping', function (e) {
        $(this).parents('.calendar-mapping').remove();
    });

    if($('.calendar-builder-form').length){
        $(window).keydown(function(event){
            if( (event.keyCode == 13)) {
                event.preventDefault();
                return false;
            }
        });
    }

    $('.calendar-builder-form').one('submit', handleCalendarBuilderFormChange);

    function handleCalendarBuilderFormChange(e) {
        e.preventDefault();

        let errors = false,
            $mappings = $('.calendar-mappings-holder').find('.calendar-mapping'),
            calendar_mappings = [];

        if (!$mappings.length) {
            errors = true;
            alert('Please add mappings');
        } else {
            $mappings.each(function (index, $mapping) {
                let field = $($mapping).find('.calendar-field').val(),
                    type = $($mapping).find('.calendar-field-value-type').val(),
                    field_type = $($mapping).find('.calendar-field').find('option:selected').attr('data-field-type'),
                    field_type_value = parseInt($($mapping).find('.calendar-field-value-type').val()),
                    $link =  $($mapping).find('.add-label-link'),
                    required = $($mapping).find('.toggle-required').is(':checked') ? 1 : 0,
                    link_text = $link.attr('data-text'),
                    link_url = $link.attr('data-link'),
                    open_blank = $link.attr('data-open-blank'),
                    value = '';

                if (parseInt(type) === 2) {
                    value = $($mapping).find('.custom-value').val();

                    if ($($mapping).find('select.custom-value').length) {
                        value = $($mapping).find('select.custom-value').val();
                    }

                    let date_payload = {};

                    if (field_type === 'date') {
                        date_payload.type = 'date';
                        let days = $($mapping).find('.days').val();
                        date_payload.days = days;

                        value = JSON.stringify(date_payload);
                    } else if (field_type === 'datetime') {
                        date_payload.type = 'datetime';
                        let days = $($mapping).find('.days').val(),
                            hours = $($mapping).find('.hours').val(),
                            minutes = $($mapping).find('.minutes').val();
                        date_payload.days = days;
                        date_payload.hours = hours;
                        date_payload.minutes = minutes;
                        value = JSON.stringify(date_payload);
                    }
                }

                if (!field.length) {
                    errors = true;
                    alert('Please select field');
                }

                calendar_mappings.push({
                    field,
                    type: type,
                    value: value,
                    url: link_url,
                    text: link_text,
                    open_new_tab: open_blank,
                    required : required
                });

                console.log({
                    field,
                    type: type,
                    value: value,
                    url: link_url,
                    text: link_text,
                    open_new_tab: open_blank,
                    required : required
                });
            });
        }

        if (!errors) {
            $('input[name="calendar_mappings"]').val(JSON.stringify(calendar_mappings));
            $(this).submit();
            $('.calendar-builder-form').one('submit', handleCalendarBuilderFormChange);
        } else {
            $('.calendar-builder-form').one('submit', handleCalendarBuilderFormChange);
        }
    }

    $('.delete-calendar').on('click', function (e) {
        e.preventDefault();

        let id = $(this).attr('data-id');

        if (confirm('Are you sure you want to delete this Calendar')) {
            $.ajax({
                type: 'DELETE',
                url: '/settings/calendar',
                data: {
                    id
                },
                success: (res) => {
                    if (res) {
                        $(this).parents('tr').remove();
                    }
                }
            });
        }
    });

    $('.duplicate-calendar').on('click', function (e) {
        e.preventDefault();
        let id = $(this).attr('data-id');

        $.ajax({
            type: 'POST',
            url: '/settings/calendar/duplicate',
            data: {
                id
            },
            success: function (id) {
                window.location = '/settings/calendar/edit/' + id;
            }
        });
    });

    let date_format = $('meta[name="date-format"]').attr('content');

    function bootstrapOnlineCalendar(){
        $("#online-calender-picker").flatpickr({
            weekNumbers: true,
            dateFormat: date_format,
            closeOnSelect: true,
            allowInput: true,
            inline: true,

            onChange: function (selectedDates, dateStr, instance) {
                $(instance.element).val(dateStr);
                getEvents(selectedDates, instance, dateStr);
            },

            onReady: function(selectedDates, dateStr, instance) {
                loadEvents(instance);
                getEvents(selectedDates, instance, dateStr);
            },

            onMonthChange: function(selectedDates, dateStr, instance) {
                loadEvents(instance);
            },

            onYearChange: function(selectedDates, dateStr, instance) {
                loadEvents(instance);
            }
        });
    }
    bootstrapOnlineCalendar();

    $(document).on('click', '.event-slot', function(e){
        e.preventDefault();

        let $calendar_container = $('.calendar-container'),
            $form = $('.contact-form');

        $('.event-slot').removeClass('selected');
        $(this).addClass('selected');
        let id = $(this).attr('data-id');
        $('input[name="_available_slot"]').val(id);

        $calendar_container.addClass('d-none');
        $form.removeClass('d-none');
    });

    $(document).on('click', '.hide-form', function(e){
        e.preventDefault();

        let $calendar_container = $('.calendar-container'),
            $form = $('.contact-form');

        $form.addClass('d-none');
        $calendar_container.removeClass('d-none');
        bootstrapOnlineCalendar();
    });

    function getEvents(selectedDates, instance, dateStr){
        if (selectedDates.length) {
            let calendarId = $(instance.element).data("id");
            let selectedDate = dateStr;

            $('input[name="_calendar_date"]').val(selectedDate);

            $.ajax({
                url: `/embed/calendar/${calendarId}/events`,
                method: "GET",
                data: { date: selectedDate },
                success: function(events) {
                    displayEvents(events);
                },
                error: function() {
                    displayEvents([]);
                }
            });
        }
    }

    // Load enabled dates from backend
    function loadEvents(instance) {
        let calendarId = $(instance.element).data("id");

        let month = instance.currentMonth + 1;
        let year  = instance.currentYear;

        let start = `${year}-${String(month).padStart(2,"0")}-01`;
        let end   = `${year}-${String(month).padStart(2,"0")}-31`;

        $.ajax({
            url: `/embed/calendar/${calendarId}/days`,
            method: "GET",
            data: { start, end },

            success: function(res) {
                // Reset rules safely
                instance.config.enable = [];
                instance.config.disable = [];

                if (res.length) {
                    // Map date strings to actual Date objects
                    let enabledDates = res.map(d => new Date(d));
                    instance.set("enable", enabledDates);
                } else {
                    // Disable ALL: use function that always returns false
                    instance.set("enable", [function() { return false; }]);
                }

                // Force calendar redraw
                instance.redraw();
            }
        });
    }

    function displayEvents($events) {
        let container = $("#day-events");
        container.empty().append($events);
        let id = $('input[name="_available_slot"]').val();

        if(id.length){
            $(`.event-slot[data-id="${id}"]`).addClass('selected');
        }
    }
});